"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrencyItem = CurrencyItem;
exports.CurrencySelector = CurrencySelector;
exports.currencyRedirect = currencyRedirect;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _core = require("@linaria/core");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _icon = require("@site/pattern-library-utils/icon");
var _closeButton = _interopRequireDefault(require("@site/pattern-library-core/close-button"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CurrencySelectorContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CurrencySelectorContainer",
  class: "pl-cabwquw"
});
const CurrencyItemContainer = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "CurrencyItemContainer",
  class: "pl-coax107",
  vars: {
    "coax107-0": [props => props.selected ? _intents.default.ux.boxHighContrast.foregroundColor : _intents.default.ux.boxHighContrast.backgroundColor],
    "coax107-1": [props => props.selected ? '#00a4a6' : 'transparent'],
    "coax107-2": [props => props.selected ? '#00a4a6' : '#f5f7f8']
  }
});
const Divider = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Divider",
  class: "pl-d1ebp72v"
});
const Tray = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Tray",
  class: "pl-t15dk045"
});
const TrayToggleWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TrayToggleWrapper",
  class: "pl-tqf1nid"
});
const TrayToggle = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "TrayToggle",
  class: "pl-tijxvcn",
  vars: {
    "tijxvcn-2": [props => props.trayOpen ? 'rotate(180deg)' : 'rotate(0deg)']
  }
});
const TrayContent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TrayContent",
  class: "pl-t13o0yn8"
});
const closeButtonStyles = "pl-c10h174l";

/**
 * Visitor clicks on a currency item.
 *
 * @param {string} currencytype The currently selected currency object
 * @param {string} url API to update selected currency
 * @public
 */
async function currencyRedirect(currencytype, url) {
  fetch(url + '/' + currencytype, {
    credentials: 'include'
  }).then(() => {
    const redirectUrl = new URL(window.location.href);
    if (redirectUrl.searchParams.has('currency')) {
      redirectUrl.searchParams.delete('currency');

      // If the URL is changing, we must truly redirect to it
      window.location.assign(redirectUrl.href);
    } else {
      // If the URL is the same, we can simply reload, so that hash URLs work
      window.location.reload();
    }
  }).catch(() => {});
}

/**
 * Footer Controls component.
 *
 * @param {Object} props React props
 * @param {React.Ref<HTMLElement>} props.container Container
 * @param {string} props.url API to update selected currency
 * @param {string} props.id Currency
 * @param {object} props.symbol Symbol
 * @param {boolean} [props.selected=false] Item is selected currency
 * @returns {React.ReactElement} Currency Item button
 * @public
 */
function CurrencyItem({
  container,
  url,
  id,
  symbol,
  selected = false
}) {
  return /*#__PURE__*/_react.default.createElement(CurrencyItemContainer, {
    type: "button",
    "data-currencyid": id,
    selected: selected,
    "data-cy": "currency-item",
    onClick: () => {
      container?.current?.blur();
      currencyRedirect(id, url);
    }
  }, id, " ", symbol.Value);
}
CurrencyItem.propTypes = {
  currencytype: _propTypes.default.string,
  id: _propTypes.default.string,
  symbol: _propTypes.default.object,
  url: _propTypes.default.string,
  container: _propTypes.default.object,
  selected: _propTypes.default.bool
};

/**
 * @typedef {Object} CurrencyItem GUI currency definition, see https://gui.godaddy.com/pcjson/currency/display
 * @property {string} id Currency code
 * @property {string} symbol Currency symbol
 */
/**
 * Footer Controls component.
 *
 * @param {Object} props React props
 *  @param {string} props.id ID
 * @param {string} props.ariaLabel Aria Label
 * @param {string} props.setCurrencyUrl Url to GUI for setting new currency (Ex: https://gui.godaddy.com/preference/currency/set)
 * @param {CurrencyItem[]} props.currencyList Currency list
 * @param {string} props.selectedCurrency Initial Selected Currency
 * @param {CurrencyItem[]} props.primaryCurrencyList Primary Currency list
 * @returns {React.ReactElement} Currency Selector component
 * @public
 */
function CurrencySelector({
  id,
  setCurrencyUrl,
  ariaLabel,
  currencyList,
  selectedCurrency,
  primaryCurrencyList
}) {
  const [trayOpen, setTrayOpen] = (0, _react.useState)(false);
  const container = (0, _react.useRef)(null);
  const selector = (0, _react.useRef)(null);
  const renderCurrencyList = (currency, index) => /*#__PURE__*/_react.default.createElement(CurrencyItem, (0, _extends2.default)({
    key: `${currency.symbol.Value}-${index}`
  }, currency, {
    container: container,
    url: setCurrencyUrl,
    selected: selectedCurrency && selectedCurrency.id === currency.id
  }));
  const exitOnEscape = ({
    keyCode
  }) => {
    if (keyCode === 27) {
      setTrayOpen(false);
    }
  };
  const exitOnClick = ({
    target
  }) => {
    if (selector.current && !selector.current.contains(target)) {
      setTrayOpen(false);
    }
  };
  (0, _react.useEffect)(() => {
    if (typeof document !== 'undefined') {
      document.addEventListener('keydown', exitOnEscape, false);
      document.addEventListener('mousedown', exitOnClick, false);
      return () => {
        document.removeEventListener('keydown', exitOnEscape, false);
        document.removeEventListener('mousedown', exitOnClick, false);
      };
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(CurrencySelectorContainer, {
    id: `id-${id}`,
    tabIndex: "-1",
    "data-cy": "currency-selector",
    ref: selector
  }, /*#__PURE__*/_react.default.createElement(TrayToggleWrapper, null, /*#__PURE__*/_react.default.createElement(TrayToggle, {
    id: "currentCurrency",
    "aria-label": ariaLabel.replace('{currency}', selectedCurrency && selectedCurrency),
    tabIndex: "0",
    "aria-haspopup": "true",
    type: "button",
    "aria-expanded": trayOpen,
    trayOpen: trayOpen,
    onClick: () => setTrayOpen(!trayOpen),
    onKeyPress: e => {
      e.preventDefault();
      if (e.key === 'Enter') {
        setTrayOpen(!trayOpen);
      }
    }
  }, `${selectedCurrency.id} ${selectedCurrency.symbol.Value}`, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-up",
    fill: "white"
  }))), /*#__PURE__*/_react.default.createElement(Tray, {
    tabIndex: "-1",
    className: trayOpen ? 'open' : 'close'
  }, /*#__PURE__*/_react.default.createElement(TrayContent, null, /*#__PURE__*/_react.default.createElement(_closeButton.default, {
    onClose: () => setTrayOpen(false),
    className: closeButtonStyles
  }), primaryCurrencyList?.map(renderCurrencyList), /*#__PURE__*/_react.default.createElement(Divider, null), currencyList?.map(renderCurrencyList))));
}
CurrencySelector.propTypes = {
  id: _propTypes.default.string,
  ariaLabel: _propTypes.default.string,
  setCurrencyUrl: _propTypes.default.string.isRequired,
  currencyList: _propTypes.default.array,
  selectedCurrency: _propTypes.default.object,
  primaryCurrencyList: _propTypes.default.array
};